
























import LazyHydrate from 'vue-lazy-hydration';
import { useRoute, defineComponent, ssrRef } from '@nuxtjs/composition-api';
import { ProductInterface, useFacet, useUiState } from '~/composables';
import AppHeader from '~/components/AppHeader.vue';
import AppFooter from '~/components/AppFooter.vue';
import BottomNavigation from '~/components/BottomNavigation.vue';
import IconSprite from '~/components/General/IconSprite.vue';
import TopBar from '~/components/TopBar/TopBar.vue';
import facetGetters from '~/modules/catalog/category/getters/facetGetters';

export default defineComponent({
  name: 'DefaultLayout',

  components: {
    LazyHydrate,
    AppHeader,
    AppFooter,
    BottomNavigation,
    IconSprite,
    TopBar,
    CartSidebar: () =>
      import(
        /* webpackPrefetch: true */ '~/modules/checkout/components/CartSidebar.vue'
      ),
    WishlistSidebar: () =>
      import(
        /* webpackPrefetch<abbr: true */ '~/modules/wishlist/components/WishlistSidebar.vue'
      ),
    LoginModal: () =>
      import(
        /* webpackPrefetch: true */ '~/modules/customer/components/LoginModal/LoginModal.vue'
      ),
    Notification: () =>
      import(/* webpackPrefetch: true */ '~/components/Notification.vue'),
  },

  setup() {
    const { result } = useFacet();
    const products = ssrRef<ProductInterface[]>([]);

    products.value = facetGetters.getProducts(result.value) ?? [];

    const route = useRoute();
    const {
      isCartSidebarOpen,
      isWishlistSidebarOpen,
      isLoginModalOpen,
      toggleLoginModal,
    } = useUiState();

    return {
      isCartSidebarOpen,
      isWishlistSidebarOpen,
      isLoginModalOpen,
      toggleLoginModal,
      route,
    };
  },
  head: {
    link: [
      { rel: 'stylesheet', href: '/_nuxt/fonts.css' },
      {
        rel: 'icon',
        type: 'image/x-icon',
        href: '/favicon.ico',
      },
    ],
  },
});
